module.exports = __webpack_public_path__ + "static/media/jumbotronQuality.54acc4cf.jpg";